export default __webpack_public_path__ + "static/media/5.aac65ee5.png";